<template>
    <div class="data-view-container">
        <!-- 隐藏的图标组件使用，解决ESLint警告 -->
        <CopyDocument style="display: none;" />

        <!-- 添加TopBar组件 -->
        <TopBar :user="user" :apps="apps" />

        <h1>数据梳理系统</h1>

        <!-- 三个横向分布的版块 -->
        <div class="panels-container">
            <!-- 第一个版块：Info数据表列表 -->
            <div class="panel info-panel">
                <div class="panel-header">
                    <h2>信息管理</h2>
                    <el-button type="primary" @click="showAddInfoDialog = true" size="small">添加信息</el-button>
                </div>

                <!-- Info数据列表 -->
                <div class="panel-content">
                    <!-- 搜索和排序控件 -->
                    <div class="controls-bar">
                        <el-input v-model="infoSearchKeyword" placeholder="搜索信息..." clearable @clear="searchInfo"
                            @input="searchInfo" style="width: 200px; margin-right: 10px;">
                            <template #prefix>
                                <el-icon>
                                    <Search />
                                </el-icon>
                            </template>
                        </el-input>
                        <el-button type="primary" @click="searchInfo" size="small">搜索</el-button>
                        <el-select v-model="infoSortField" @change="sortInfo" placeholder="排序字段" size="small"
                            style="margin-left: 10px; width: 120px;">
                            <el-option label="ID" value="id"></el-option>
                            <el-option label="创建时间" value="created_at"></el-option>
                            <el-option label="姓名" value="name"></el-option>
                            <el-option label="城市" value="city"></el-option>
                            <el-option label="平台编号" value="ptnum"></el-option>
                        </el-select>
                        <el-select v-model="infoSortOrder" @change="sortInfo" placeholder="排序方式" size="small"
                            style="margin-left: 5px; width: 100px;">
                            <el-option label="升序" value=""></el-option>
                            <el-option label="降序" value="-"></el-option>
                        </el-select>
                        <div class="total-count">总数: {{ infoTotalCount }}</div>
                    </div>

                    <el-table :data="infoList" style="width: 100%" border>
                        <el-table-column prop="id" label="ID" width="60">
                            <template #default="scope">
                                <div style="display: flex; align-items: center;">
                                    <span>{{ scope.row.id }}</span>
                                    <el-button type="primary" size="small" style="margin-left: 5px; padding: 4px;"
                                        @click="copyRawInfo(scope.row.raw_info)">
                                        <el-icon>
                                            <CopyDocument />
                                        </el-icon>
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="province" label="省份" width="60"></el-table-column>
                        <el-table-column prop="city" label="城市" width="60"></el-table-column>
                        <el-table-column prop="district" label="地区" width="60"></el-table-column>
                        <el-table-column prop="ptnum" label="平台编号" width="100"></el-table-column>
                        <el-table-column prop="infoTypeName" label="信息类型" width="90"></el-table-column>
                        <el-table-column prop="status" label="状态" width="100">
                            <template #default="scope">
                                <el-select v-model="scope.row.status" @change="updateInfoStatus(scope.row)" size="small"
                                    style="width: 100%">
                                    <el-option label="未发放" value="未发放"></el-option>
                                    <el-option label="已发放" value="已发放"></el-option>
                                    <el-option label="无效" value="无效"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="150">
                            <template #default="scope">
                                <el-button size="small" @click="editInfo(scope.row)">编辑</el-button>
                                <el-button size="small" type="danger" @click="deleteInfo(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createdAt" label="创建时间" width="260"></el-table-column>

                    </el-table>

                    <!-- Info分页控件 -->
                    <div class="pagination-container">
                        <el-pagination v-model:current-page="infoCurrentPage" v-model:page-size="infoPageSize"
                            :page-sizes="[10, 20, 50, 100]" :total="infoTotalCount"
                            layout="total, sizes, prev, pager, next, jumper" @size-change="handleInfoSizeChange"
                            @current-change="handleInfoCurrentChange" />
                    </div>
                </div>
            </div>

            <!-- 第二个版块：People数据 -->
            <div class="panel people-panel">
                <div class="panel-header">
                    <h2>人员管理</h2>
                    <el-button type="primary" @click="showAddPeopleDialog = true" size="small">添加人员</el-button>
                </div>

                <!-- People数据列表 -->
                <div class="panel-content">
                    <!-- 搜索和排序控件 -->
                    <div class="controls-bar">
                        <el-input v-model="peopleSearchKeyword" placeholder="搜索人员..." clearable @clear="searchPeople"
                            @input="searchPeople" style="width: 200px; margin-right: 10px;">
                            <template #prefix>
                                <el-icon>
                                    <Search />
                                </el-icon>
                            </template>
                        </el-input>
                        <el-button type="primary" @click="searchPeople" size="small">搜索</el-button>
                        <el-select v-model="peopleSortField" @change="sortPeople" placeholder="排序字段" size="small"
                            style="margin-left: 10px; width: 120px;">
                            <el-option label="ID" value="id"></el-option>
                            <el-option label="创建时间" value="created_at"></el-option>
                            <el-option label="姓名" value="name"></el-option>
                            <el-option label="电话" value="phone"></el-option>
                        </el-select>
                        <el-select v-model="peopleSortOrder" @change="sortPeople" placeholder="排序方式" size="small"
                            style="margin-left: 5px; width: 100px;">
                            <el-option label="升序" value=""></el-option>
                            <el-option label="降序" value="-"></el-option>
                        </el-select>
                        <div class="total-count">总数: {{ peopleTotalCount }}</div>
                    </div>

                    <el-table :data="peopleList" style="width: 100%" border>
                        <el-table-column prop="id" label="ID" width="50"></el-table-column>
                        <el-table-column prop="name" label="姓名" width="60"></el-table-column>
                        <el-table-column prop="phone" label="电话" width="120"></el-table-column>
                        <el-table-column prop="wechat" label="微信" width="120"></el-table-column>
                        <el-table-column prop="province" label="省份" width="60"></el-table-column>
                        <el-table-column prop="city" label="城市" width="60"></el-table-column>
                        <el-table-column prop="district" label="地区" width="60"></el-table-column>
                        <el-table-column prop="status" label="状态" width="100">
                            <template #default="scope">
                                <el-select v-model="scope.row.status" @change="updatePeopleStatus(scope.row)"
                                    size="small" style="width: 100%">
                                    <el-option label="已添加" value="added"></el-option>
                                    <el-option label="未添加" value="not_added"></el-option>
                                    <el-option label="忽略" value="ignored"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" width="150"></el-table-column>
                        <el-table-column label="操作" width="150">
                            <template #default="scope">
                                <el-button size="small" @click="editPeople(scope.row)">编辑</el-button>
                                <el-button size="small" type="danger" @click="deletePeople(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- People分页控件 -->
                    <div class="pagination-container">
                        <el-pagination v-model:current-page="peopleCurrentPage" v-model:page-size="peoplePageSize"
                            :page-sizes="[10, 20, 50, 100]" :total="peopleTotalCount"
                            layout="total, sizes, prev, pager, next, jumper" @size-change="handlePeopleSizeChange"
                            @current-change="handlePeopleCurrentChange" />
                    </div>
                </div>
            </div>

            <!-- 第三个版块：数据分析页面 -->
            <div class="panel analysis-panel">
                <div class="panel-header">
                    <h2>数据分析</h2>
                </div>

                <div class="panel-content">
                    <!-- 数据分析框 -->
                    <div class="analysis-section">
                        <el-input type="textarea" v-model="rawInfo" placeholder="请输入需要分析的原始信息" :rows="6"
                            class="raw-info-input"></el-input>
                        <el-button type="primary" @click="parseInfo" class="parse-button">解析信息</el-button>
                    </div>

                    <!-- 解析结果展示 -->
                    <div v-if="parsedInfo" class="parsed-result-section">
                        <h3>解析结果</h3>

                        <!-- 信息类型选择 -->
                        <div class="form-item">
                            <label>信息类型：</label>
                            <el-select v-model="parsedInfo.info_type" placeholder="请选择信息类型" @change="onInfoTypeChange">
                                <el-option v-for="item in infoTypes" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <el-button @click="showAddInfoTypeDialog = true" size="small">添加类型</el-button>
                        </div>

                        <!-- 姓名 -->
                        <div class="form-item">
                            <label>姓名：</label>
                            <el-input v-model="parsedInfo.name" placeholder="请输入姓名"></el-input>
                        </div>

                        <!-- 省份选择 -->
                        <div class="form-item">
                            <label>省份：</label>
                            <el-select v-model="parsedInfo.province" placeholder="请选择省份" @change="onProvinceChange">
                                <el-option v-for="province in provinces" :key="province" :label="province"
                                    :value="province"></el-option>
                            </el-select>
                        </div>

                        <!-- 城市选择 -->
                        <div class="form-item">
                            <label>城市：</label>
                            <el-select v-model="parsedInfo.city" placeholder="请选择城市" @change="onCityChange">
                                <el-option label="镇江" value="镇江"></el-option>
                                <el-option label="南京" value="南京"></el-option>
                            </el-select>
                        </div>

                        <!-- 地区选择 -->
                        <div class="form-item">
                            <label>地区：</label>
                            <el-select v-model="parsedInfo.district" placeholder="请选择地区" @change="onDistrictChange">
                                <el-option v-for="district in districts" :key="district" :label="district"
                                    :value="district"></el-option>
                            </el-select>
                        </div>



                        <div class="form-item">
                            <label>地址：</label>
                            <el-input v-model="parsedInfo.address" placeholder="请输入详细地址"></el-input>
                        </div>

                        <!-- 电话号码列表 -->
                        <div class="phone-list-section">
                            <h4>电话号码列表</h4>
                            <div v-for="(phone, index) in parsedInfo.phones" :key="index" class="phone-item">
                                <el-input v-model="parsedInfo.phones[index]" placeholder="电话号码"
                                    style="width: 200px;"></el-input>

                                <!-- 匹配的人员信息 -->
                                <div v-if="phonePeopleMap[phone] && phonePeopleMap[phone].length > 0"
                                    class="people-match">
                                    <span>匹配人员：</span>
                                    <el-tag v-for="people in phonePeopleMap[phone]" :key="people.id" type="success"
                                        @click="selectPeopleForPhone(phone, people)">
                                        {{ people.name }} (ID: {{ people.id }})
                                    </el-tag>
                                </div>

                                <!-- 未匹配时显示添加人员表单 -->
                                <div v-else class="people-form">
                                    <el-input v-model="newPeopleData[phone].name" placeholder="姓名" size="small"
                                        style="width: 100px;"></el-input>
                                    <!-- 省份选择 -->
                                    <el-select v-model="newPeopleData[phone].province" placeholder="请选择省份" size="small"
                                        style="width: 100px;">
                                        <el-option v-for="province in provinces" :key="province" :label="province"
                                            :value="province"></el-option>
                                    </el-select>
                                    <!-- 城市选择 -->
                                    <el-select v-model="newPeopleData[phone].city" placeholder="请选择城市" size="small"
                                        style="width: 100px;">
                                        <el-option label="镇江" value="镇江"></el-option>
                                        <el-option label="南京" value="南京"></el-option>
                                    </el-select>
                                    <!-- 地区选择 -->
                                    <el-select v-model="newPeopleData[phone].district" placeholder="请选择地区" size="small"
                                        style="width: 100px;">
                                        <el-option v-for="district in districts" :key="district" :label="district"
                                            :value="district"></el-option>
                                    </el-select>
                                    <el-button type="success" size="small" @click="addPeopleForPhone(phone)">
                                        添加
                                    </el-button>
                                </div>

                                <el-button type="danger" size="small" @click="removePhone(index)">
                                    删除
                                </el-button>
                            </div>

                            <el-button @click="addPhone" type="primary" size="small">添加电话</el-button>
                        </div>

                        <!-- 保存按钮 -->
                        <div class="save-section">
                            <el-button type="success" @click="saveParsedInfo">一键保存</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 添加信息对话框 -->
        <el-dialog title="添加信息" v-model="showAddInfoDialog" width="60%">
            <el-form :model="currentInfo" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="currentInfo.name"></el-input>
                </el-form-item>
                <el-form-item label="信息类型">
                    <el-select v-model="currentInfo.info_type" placeholder="请选择信息类型">
                        <el-option v-for="item in infoTypes" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台编号">
                    <el-input v-model="currentInfo.ptnum"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="currentInfo.status" placeholder="请选择状态">
                        <el-option label="未发放" value="未发放"></el-option>
                        <el-option label="已发放" value="已发放"></el-option>
                        <el-option label="无效" value="无效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省份">
                    <el-select v-model="currentInfo.province" placeholder="请选择省份">
                        <el-option v-for="province in provinces" :key="province" :label="province"
                            :value="province"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="城市">
                    <el-select v-model="currentInfo.city" placeholder="请选择城市">
                        <el-option label="镇江" value="镇江"></el-option>
                        <el-option label="南京" value="南京"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地区">
                    <el-select v-model="currentInfo.district" placeholder="请选择地区">
                        <el-option v-for="district in districts" :key="district" :label="district"
                            :value="district"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="currentInfo.remark" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="原始信息">
                    <el-input type="textarea" v-model="currentInfo.raw_info" :rows="4"></el-input>
                </el-form-item>

                <!-- 关联人员列表 -->
                <el-form-item label="关联人员" v-if="currentInfo.id && infoRelatedPeople.length > 0">
                    <div class="related-people-list">
                        <el-tag v-for="person in infoRelatedPeople" :key="person.id" closable
                            @close="removeRelatedPersonFromInfo(person)" type="success" style="margin: 5px;">
                            #{{ person.id }} - {{ person.name }} ({{ person.phone }})
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showAddInfoDialog = false">取消</el-button>
                <el-button type="primary" @click="saveInfo">确定</el-button>
            </template>
        </el-dialog>

        <!-- 添加人员对话框 -->
        <el-dialog title="添加人员" v-model="showAddPeopleDialog" width="60%">
            <el-form :model="currentPeople" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="currentPeople.name"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="currentPeople.phone"></el-input>
                </el-form-item>
                <el-form-item label="省份">
                    <el-input v-model="currentPeople.province"></el-input>
                </el-form-item>
                <el-form-item label="城市">
                    <el-input v-model="currentPeople.city"></el-input>
                </el-form-item>
                <el-form-item label="地区">
                    <el-input v-model="currentPeople.district"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="currentPeople.address"></el-input>
                </el-form-item>
                <el-form-item label="微信号">
                    <el-input v-model="currentPeople.wechat"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="currentPeople.status" placeholder="请选择状态">
                        <el-option label="已添加" value="added"></el-option>
                        <el-option label="未添加" value="not_added"></el-option>
                        <el-option label="忽略" value="ignored"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="currentPeople.remark" :rows="3"></el-input>
                </el-form-item>

                <!-- 关联信息列表 -->
                <el-form-item label="关联信息" v-if="currentPeople.id && peopleRelatedInfos.length > 0">
                    <div class="related-infos-list">
                        <el-tag v-for="info in peopleRelatedInfos" :key="info.id" closable
                            @close="removeRelatedInfoFromPeople(info)" type="primary" style="margin: 5px;">
                            #{{ info.id }} - {{ info.info_type_name }}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showAddPeopleDialog = false">取消</el-button>
                <el-button type="primary" @click="savePeople">确定</el-button>
            </template>
        </el-dialog>

        <!-- 添加信息类型对话框 -->
        <el-dialog title="添加信息类型" v-model="showAddInfoTypeDialog" width="30%">
            <el-input v-model="newInfoTypeName" placeholder="请输入信息类型名称"></el-input>
            <template #footer>
                <el-button @click="showAddInfoTypeDialog = false">取消</el-button>
                <el-button type="primary" @click="addInfoType">确定</el-button>
            </template>
        </el-dialog>

        <!-- 信息重复对比对话框 -->
        <el-dialog title="信息重复检测" v-model="showDuplicateInfoDialog" width="80%">
            <div class="duplicate-comparison">
                <h3>检测到可能重复的信息</h3>
                <div class="comparison-container">
                    <div class="comparison-panel">
                        <h4>现有信息</h4>
                        <div class="info-content">{{ duplicateInfo.existing?.raw_info }}</div>
                        <div class="similarity">相似度: {{ duplicateInfo.similarity }}%</div>
                    </div>
                    <div class="comparison-panel">
                        <h4>新增信息</h4>
                        <div class="info-content">{{ duplicateInfo.new?.raw_info }}</div>
                    </div>
                </div>
            </div>
            <template #footer>
                <el-button @click="handleDuplicateCancel">取消</el-button>
                <el-button type="primary" @click="handleDuplicateConfirm">确认添加</el-button>
            </template>
        </el-dialog>

        <!-- 人员电话重复对话框 -->
        <el-dialog title="电话号码已存在" v-model="showDuplicatePeopleDialog" width="50%">
            <p>电话号码 {{ duplicatePeople.phone }} 已存在，对应人员信息如下：</p>
            <div class="people-info">
                <p>姓名: {{ duplicatePeople.existing?.name }}</p>
                <p>省份: {{ duplicatePeople.existing?.province }}</p>
                <p>城市: {{ duplicatePeople.existing?.city }}</p>
                <p>地区: {{ duplicatePeople.existing?.district }}</p>
            </div>
            <p>请选择操作：</p>
            <template #footer>
                <el-button @click="handlePeopleCancel">取消</el-button>
                <el-button @click="handlePeopleModify">修改</el-button>
                <el-button type="primary" @click="handlePeopleOverride">覆盖</el-button>
            </template>
        </el-dialog>

        <!-- 解析信息确认对话框 -->
        <el-dialog title="信息重复确认" v-model="showParseConfirmDialog" width="50%">
            <p>检测到相似信息，相似度为 {{ parseDuplicateInfo.similarity }}%</p>
            <p>是否继续解析？</p>
            <template #footer>
                <el-button @click="handleParseCancel">取消</el-button>
                <el-button type="primary" @click="handleParseConfirm">确认解析</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { Search, CopyDocument } from '@element-plus/icons-vue'
import InfoService from '@/services/infoService'
import TopBar from '@/components/TopBar.vue'
import AuthService from '@/services/authService.js'
import UserMainService from '@/services/userMainService.js'
import config from '@/config'
export default {
    name: 'DataView',
    components: {
        Search,
        CopyDocument,
        TopBar
    },
    setup() {
        // 设置axios基础URL
        axios.defaults.baseURL = 'http://localhost:8000'

        // TopBar相关数据
        const user = ref({
            name: '用户名',
            id: 1,
            userType: 1,
            avatar: require('@/assets/logo.png')
        })

        const apps = ref([])

        // Info数据列表
        const infoList = ref([])

        // People数据列表
        const peopleList = ref([])

        // 当前编辑的Info数据
        const currentInfo = reactive({
            id: null,
            name: '',
            info_type: '',
            status: '未发放',
            raw_info: '',
            province: '',
            city: '',
            district: '',
            ptnum: '',
            remark: ''
        })

        // 当前编辑的People数据
        const currentPeople = reactive({
            id: null,
            name: '',
            phone: '',
            province: '',
            city: '',
            district: '',
            address: '',
            wechat: '',
            status: 'not_added',
            remark: ''
        })

        // 信息关联的人员列表
        const infoRelatedPeople = ref([])

        // 人员关联的信息列表
        const peopleRelatedInfos = ref([])

        // 显示添加Info对话框
        const showAddInfoDialog = ref(false)

        // 显示添加People对话框
        const showAddPeopleDialog = ref(false)

        // 原始信息
        const rawInfo = ref('')

        // 解析后的信息
        const parsedInfo = ref(null)

        // 信息类型列表
        const infoTypes = ref([])

        // 省份列表
        const provinces = ref(['江苏'])

        // 地区列表
        const districts = ref(['润洲', '京口', '句容', '下蜀', '高资', '宝华', '丹徒新区'])

        // 电话号码与人员的映射关系
        const phonePeopleMap = ref({})

        // 新增人员数据
        const newPeopleData = reactive({})

        // 显示添加信息类型对话框
        const showAddInfoTypeDialog = ref(false)

        // 新信息类型名称
        const newInfoTypeName = ref('')

        // 显示信息重复对话框
        const showDuplicateInfoDialog = ref(false)

        // 重复信息数据
        const duplicateInfo = reactive({
            existing: null,
            new: null,
            similarity: 0
        })

        // 显示人员重复对话框
        const showDuplicatePeopleDialog = ref(false)

        // 重复人员数据
        const duplicatePeople = reactive({
            phone: '',
            existing: null,
            new: null
        })

        // 显示解析确认对话框
        const showParseConfirmDialog = ref(false)

        // 解析重复信息数据
        const parseDuplicateInfo = reactive({
            existing: null,
            new: null,
            similarity: 0
        })

        // Info分页相关数据
        const infoCurrentPage = ref(1)
        const infoPageSize = ref(10)
        const infoTotalCount = ref(0)
        const infoSearchKeyword = ref('')
        const infoSortField = ref('created_at')
        const infoSortOrder = ref('-')

        // People分页相关数据
        const peopleCurrentPage = ref(1)
        const peoplePageSize = ref(10)
        const peopleTotalCount = ref(0)
        const peopleSearchKeyword = ref('')
        const peopleSortField = ref('created_at')
        const peopleSortOrder = ref('-')

        // 获取Info数据列表（带分页、搜索和排序）
        const getInfoList = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                // 向后端传递分页参数
                const params = {
                    page: infoCurrentPage.value,
                    page_size: infoPageSize.value,
                    search: infoSearchKeyword.value,
                    sort_field: infoSortField.value,
                    sort_order: infoSortOrder.value
                };

                const response = await InfoService.getInfos(params)
                if (response.status === 'ok') {
                    // 后端已经处理了分页，直接使用返回的数据
                    infoList.value = response.infos.map(item => ({
                        ...item,
                        infoTypeName: infoTypes.value.find(type => type.id === item.info_type)?.name || '',
                        status: item.status || '未发放',
                        createdAt: new Date(item.created_at).toLocaleString(),
                        province: item.province || '',
                        city: item.city || '',
                        district: item.district || '',
                        ptnum: item.ptnum || '',
                        remark: item.remark || ''
                    }))
                    infoTotalCount.value = response.total_count || response.infos.length
                } else {
                    throw new Error(response.message || '获取信息列表失败')
                }
            } catch (error) {
                console.error('获取信息列表失败:', error)
                ElMessage.error('获取信息列表失败')
            }
        }

        // 获取People数据列表（带分页、搜索和排序）
        const getPeopleList = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                // 向后端传递分页参数
                const params = {
                    page: peopleCurrentPage.value,
                    page_size: peoplePageSize.value,
                    search: peopleSearchKeyword.value,
                    sort_field: peopleSortField.value,
                    sort_order: peopleSortOrder.value
                };

                const response = await InfoService.getPeople(params)
                if (response.status === 'ok') {
                    // 后端已经处理了分页，直接使用返回的数据
                    peopleList.value = response.people.map(item => ({
                        ...item,
                        statusDisplay: getStatusDisplay(item.status),
                        createdAt: new Date(item.created_at).toLocaleString()
                    }))
                    peopleTotalCount.value = response.total_count || response.people.length
                } else {
                    throw new Error(response.message || '获取人员列表失败')
                }
            } catch (error) {
                console.error('获取人员列表失败:', error)
                ElMessage.error('获取人员列表失败')
            }
        }

        // 获取信息类型列表
        const getInfoTypes = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getInfoTypes()
                if (response.status === 'ok') {
                    infoTypes.value = response.info_types
                } else {
                    throw new Error(response.message || '获取信息类型失败')
                }
            } catch (error) {
                console.error('获取信息类型失败:', error)
                ElMessage.error('获取信息类型失败')
            }
        }        // 获取状态显示文本
        const getStatusDisplay = (status) => {
            const statusMap = {
                'added': '已添加',
                'not_added': '未添加',
                'ignored': '忽略'
            }
            return statusMap[status] || status
        }

        // 获取状态标签类型
        const getStatusTagType = (status) => {
            const typeMap = {
                '已发放': 'success',
                '未发放': 'warning',
                '无效': 'danger'
            }
            return typeMap[status] || ''
        }

        // 获取人员状态标签类型
        const getPeopleStatusTagType = (status) => {
            const typeMap = {
                '已添加': 'success',
                '未添加': 'warning',
                '忽略': 'info'
            }
            return typeMap[status] || ''
        }

        // 编辑Info数据
        const editInfo = async (info) => {
            Object.assign(currentInfo, info)
            // 获取该信息关联的人员
            await getInfoRelatedPeople(info.id)
            showAddInfoDialog.value = true
        }

        // 获取信息关联的人员
        const getInfoRelatedPeople = async (infoId) => {
            try {
                // 通过API获取特定信息的详细信息，包含关联的人员
                const response = await InfoService.getInfo(infoId)
                console.log("getInfoRelatedPeople:", response)
                if (response.status === 'ok') {
                    // 获取关联的人员
                    infoRelatedPeople.value = response.info?.related_people || []
                } else {
                    throw new Error(response.message || '获取信息关联人员失败')
                }
            } catch (error) {
                console.error('获取信息关联人员失败:', error)
                infoRelatedPeople.value = []
            }
        }

        // 编辑People数据
        const editPeople = async (people) => {
            Object.assign(currentPeople, people)
            // 获取该人员关联的信息
            await getPeopleRelatedInfos(people.id)
            showAddPeopleDialog.value = true
        }

        // 获取人员关联的信息
        const getPeopleRelatedInfos = async (peopleId) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getPeopleWithInfos(peopleId)
                if (response.status === 'ok') {
                    peopleRelatedInfos.value = response.people?.related_infos || []
                } else {
                    throw new Error(response.message || '获取人员关联信息失败')
                }
            } catch (error) {
                console.error('获取人员关联信息失败:', error)
                peopleRelatedInfos.value = []
            }
        }

        // 从信息中移除关联人员
        const removeRelatedPersonFromInfo = async (person) => {
            if (!currentInfo.id) return

            try {
                // 这里需要调用后端API来解除关联
                // 暂时只做前端移除
                infoRelatedPeople.value = infoRelatedPeople.value.filter(p => p.id !== person.id)
                ElMessage.success('已移除关联人员')
            } catch (error) {
                console.error('移除关联人员失败:', error)
                ElMessage.error('移除关联人员失败')
            }
        }

        // 从人员中移除关联信息
        const removeRelatedInfoFromPeople = async (info) => {
            if (!currentPeople.id) return

            try {
                // 这里需要调用后端API来解除关联
                // 暂时只做前端移除
                peopleRelatedInfos.value = peopleRelatedInfos.value.filter(i => i.id !== info.id)
                ElMessage.success('已移除关联信息')
            } catch (error) {
                console.error('移除关联信息失败:', error)
                ElMessage.error('移除关联信息失败')
            }
        }

        // 删除Info数据
        const deleteInfo = async (info) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.deleteInfo(info.id)
                if (response.status !== 'ok') {
                    throw new Error(response.message || '删除信息失败')
                }
                ElMessage.success('信息删除成功')
                getInfoList()
            } catch (error) {
                console.error('删除信息失败:', error)
                ElMessage.error('删除信息失败')
            }
        }

        // 保存Info数据
        const saveInfo = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                if (currentInfo.id) {
                    // 更新
                    const response = await InfoService.updateInfo(currentInfo.id, currentInfo)
                    if (response.status === 'ok') {
                        ElMessage.success('信息更新成功')
                    } else {
                        throw new Error(response.message || '信息更新失败')
                    }
                } else {
                    // 创建
                    const response = await InfoService.createInfo(currentInfo)
                    if (response.status === 'ok') {
                        ElMessage.success('信息添加成功')
                    } else {
                        throw new Error(response.message || '信息添加失败')
                    }
                }
                showAddInfoDialog.value = false
                getInfoList()
                // 重置表单
                Object.assign(currentInfo, {
                    id: null,
                    name: '',
                    info_type: '',
                    status: '未发放',
                    raw_info: '',
                    province: '',
                    city: '',
                    district: '',
                    ptnum: '',
                    remark: ''
                })
                infoRelatedPeople.value = []
            } catch (error) {
                console.error('保存信息失败:', error)
                ElMessage.error('保存信息失败')
            }
        }

        // 更新人员状态
        const updatePeopleStatus = async (people) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.updatePeople(people.id, people)
                if (response.status === 'ok') {
                    ElMessage.success('人员状态更新成功')
                    // 更新列表中的人员数据
                    const index = peopleList.value.findIndex(p => p.id === people.id)
                    if (index !== -1) {
                        peopleList.value[index] = {
                            ...response.people,
                            statusDisplay: getStatusDisplay(response.people.status),
                            createdAt: new Date(response.people.created_at).toLocaleString()
                        }
                    }
                } else {
                    throw new Error(response.message || '人员状态更新失败')
                }
            } catch (error) {
                console.error('更新人员状态失败:', error)
                ElMessage.error('更新人员状态失败')
            }
        }

        // 删除People数据
        const deletePeople = async (people) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.deletePeople(people.id)
                if (response.status !== 'ok') {
                    throw new Error(response.message || '删除人员失败')
                }
                ElMessage.success('人员删除成功')
                getPeopleList()
            } catch (error) {
                console.error('删除人员失败:', error)
                ElMessage.error('删除人员失败')
            }
        }

        // 保存People数据
        const savePeople = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                if (currentPeople.id) {
                    // 更新
                    const response = await InfoService.updatePeople(currentPeople.id, currentPeople)
                    if (response.status === 'ok') {
                        ElMessage.success('人员更新成功')
                    } else {
                        throw new Error(response.message || '人员更新失败')
                    }
                } else {
                    // 创建
                    const response = await InfoService.createPeople(currentPeople)
                    if (response.status === 'ok') {
                        ElMessage.success('人员添加成功')
                    } else {
                        throw new Error(response.message || '人员添加失败')
                    }
                }
                showAddPeopleDialog.value = false
                getPeopleList()
                // 重置表单
                Object.assign(currentPeople, {
                    id: null,
                    name: '',
                    phone: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                    wechat: '',
                    status: 'not_added',
                    remark: ''
                })
                peopleRelatedInfos.value = []
            } catch (error) {
                console.error('保存人员失败:', error)
                ElMessage.error('保存人员失败')
            }
        }

        // 计算文本相似度
        const calculateSimilarity = (text1, text2) => {
            // 简单的相似度计算方法
            if (!text1 || !text2) return 0

            // 转换为小写并移除空格
            const str1 = text1.toLowerCase().replace(/\s/g, '')
            const str2 = text2.toLowerCase().replace(/\s/g, '')

            // 计算相似度（简单的字符匹配）
            let matchCount = 0
            const minLength = Math.min(str1.length, str2.length)

            for (let i = 0; i < minLength; i++) {
                if (str1[i] === str2[i]) {
                    matchCount++
                }
            }

            return Math.round((matchCount / Math.max(str1.length, str2.length)) * 100)
        }

        // 检查信息是否重复
        const checkInfoDuplicate = async (newInfo) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getInfos()
                if (response.status === 'ok') {
                    const existingInfos = response.infos

                    // 检查是否有重复信息
                    for (const info of existingInfos) {
                        const similarity = calculateSimilarity(info.raw_info, newInfo.raw_info)
                        if (similarity >= 90) {
                            // 发现重复信息
                            duplicateInfo.existing = info
                            duplicateInfo.new = newInfo
                            duplicateInfo.similarity = similarity
                            showDuplicateInfoDialog.value = true
                            return true
                        }
                    }
                } else {
                    throw new Error(response.message || '获取信息列表失败')
                }

                return false
            } catch (error) {
                console.error('检查信息重复失败:', error)
                return false
            }
        }

        // 检查解析时的信息重复
        const checkParseDuplicate = async (rawInfoText) => {
            console.log('Checking parse duplicate for:', rawInfoText)
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getInfos()
                if (response.status === 'ok') {
                    const existingInfos = response.infos
                    console.log('Existing infos:', existingInfos)
                    // 检查是否有重复信息
                    for (const info of existingInfos) {
                        const similarity = calculateSimilarity(info.raw_info, rawInfoText)
                        if (similarity >= 90) {
                            // 发现重复信息
                            parseDuplicateInfo.existing = info
                            parseDuplicateInfo.new = { raw_info: rawInfoText }
                            parseDuplicateInfo.similarity = similarity
                            showParseConfirmDialog.value = true
                            return true
                        }
                    }
                } else {
                    throw new Error(response.message || '获取信息列表失败')
                }

                return false
            } catch (error) {
                console.error('检查解析重复失败:', error)
                return false
            }
        }

        // 解析信息
        const parseInfo = async () => {
            if (!rawInfo.value.trim()) {
                ElMessage.warning('请输入需要分析的原始信息')
                return
            }

            // 在解析前先检查重复
            const isDuplicate = await checkParseDuplicate(rawInfo.value)
            if (isDuplicate) {
                // 如果发现重复，等待用户确认
                return
            }

            // 用户确认后继续解析
            await performParseInfo()
        }

        // 执行解析信息
        const performParseInfo = async () => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.parseInfo({
                    raw_info: rawInfo.value
                })

                if (response.status === 'ok') {
                    parsedInfo.value = response.parsed_info

                    // 自动填充默认值
                    if (!parsedInfo.value.name) {
                        parsedInfo.value.name = '无'
                    }

                    // 如果没有检测到省份，自动选择第一个
                    if (!parsedInfo.value.province) {
                        parsedInfo.value.province = provinces.value[0] || '江苏'
                    }

                    // 如果没有检测到地区，自动选择第一个
                    if (!parsedInfo.value.district) {
                        parsedInfo.value.district = districts.value[0] || '润洲'
                    }

                    // 如果没有检测到城市，设置为"镇江"
                    if (!parsedInfo.value.city || parsedInfo.value.city === '无') {
                        parsedInfo.value.city = '镇江'
                    }

                    // 如果没有检测到地址，设置为"无"
                    if (!parsedInfo.value.address) {
                        parsedInfo.value.address = '无'
                    }

                    // 初始化新人员数据
                    response.parsed_info.phones.forEach(phone => {
                        newPeopleData[phone] = {
                            name: parsedInfo.value.name !== '无' ? parsedInfo.value.name : '无',
                            province: parsedInfo.value.province,
                            city: parsedInfo.value.city,
                            district: parsedInfo.value.district,
                            address: parsedInfo.value.address,
                            phone: phone,
                            status: 'not_added',
                            remark: ''
                        }
                    })

                    // 查询电话号码匹配的人员
                    await searchPeopleByPhones(response.parsed_info.phones)

                    ElMessage.success('信息解析成功')
                } else {
                    throw new Error(response.message || '解析信息失败')
                }
            } catch (error) {
                console.error('解析信息失败:', error)
                ElMessage.error('解析信息失败: ' + (error.message || ''))
            }
        }        // 根据电话号码查询人员
        const searchPeopleByPhones = async (phones) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getPeople()
                if (response.status === 'ok') {
                    // 这里应该根据电话号码过滤人员
                    // 为了简化，我们先用空的映射
                    phonePeopleMap.value = {}
                    phones.forEach(phone => {
                        // 在实际实现中，应该根据电话号码过滤人员
                        phonePeopleMap.value[phone] = response.people.filter(person => person.phone === phone)
                    })
                } else {
                    throw new Error(response.message || '获取人员列表失败')
                }
            } catch (error) {
                console.error('查询人员信息失败:', error)
            }
        }

        // 选择人员用于电话号码
        const selectPeopleForPhone = (phone, people) => {
            // 实现选择人员的逻辑
            ElMessage.info(`选择了人员: ${people.name}`)
        }

        // 为电话号码添加人员
        const addPeopleForPhone = async (phone) => {
            const peopleData = newPeopleData[phone]
            if (!peopleData.name) {
                ElMessage.warning('请输入姓名')
                return
            }

            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.createPeople(peopleData)
                if (response.status !== 'ok') {
                    throw new Error(response.message || '添加人员失败')
                }
                ElMessage.success('人员添加成功')

                // 更新电话号码与人员的映射
                if (!phonePeopleMap.value[phone]) {
                    phonePeopleMap.value[phone] = []
                }
                phonePeopleMap.value[phone].push(response.data)

                // 清空表单
                newPeopleData[phone] = {
                    name: '',
                    province: parsedInfo.value.province,
                    city: parsedInfo.value.city,
                    district: parsedInfo.value.district,
                    address: parsedInfo.value.address,
                    phone: phone,
                    status: 'not_added',
                    remark: ''
                }
            } catch (error) {
                console.error('添加人员失败:', error)
                ElMessage.error('添加人员失败')
            }
        }

        // 添加电话号码
        const addPhone = () => {
            if (!parsedInfo.value) return
            parsedInfo.value.phones.push('')
            const newPhone = ''
            newPeopleData[newPhone] = {
                name: '无',
                province: parsedInfo.value.province,
                city: parsedInfo.value.city,
                district: parsedInfo.value.district,
                address: parsedInfo.value.address,
                phone: newPhone,
                status: 'not_added',
                remark: ''
            }
        }

        // 删除电话号码
        const removePhone = (index) => {
            if (!parsedInfo.value) return
            const phone = parsedInfo.value.phones.splice(index, 1)[0]
            delete newPeopleData[phone]
            delete phonePeopleMap.value[phone]
        }

        // 信息类型变更
        const onInfoTypeChange = (value) => {
            console.log('Info type changed:', value)
            // 实现信息类型变更的逻辑
        }

        // 监听省份变化并同步更新电话号码列表中的用户信息
        const onProvinceChange = (value) => {
            if (parsedInfo.value && newPeopleData) {
                // 遍历所有电话号码，更新其省份信息
                parsedInfo.value.phones.forEach(phone => {
                    if (newPeopleData[phone]) {
                        newPeopleData[phone].province = value;
                    }
                });
            }
        }

        // 监听城市变化并同步更新电话号码列表中的用户信息
        const onCityChange = (value) => {
            if (parsedInfo.value && newPeopleData) {
                // 遍历所有电话号码，更新其城市信息
                parsedInfo.value.phones.forEach(phone => {
                    if (newPeopleData[phone]) {
                        newPeopleData[phone].city = value;
                    }
                });
            }
        }

        // 监听地区变化并同步更新电话号码列表中的用户信息
        const onDistrictChange = (value) => {
            if (parsedInfo.value && newPeopleData) {
                // 遍历所有电话号码，更新其地区信息
                parsedInfo.value.phones.forEach(phone => {
                    if (newPeopleData[phone]) {
                        newPeopleData[phone].district = value;
                    }
                });
            }
        }

        // 添加信息类型
        const addInfoType = async () => {
            if (!newInfoTypeName.value.trim()) {
                ElMessage.warning('请输入信息类型名称')
                return
            }

            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.createInfoType({
                    name: newInfoTypeName.value
                })
                if (response.status !== 'ok') {
                    throw new Error(response.message || '添加信息类型失败')
                }

                // 假设返回的数据格式与之前相同
                infoTypes.value.push(response.data)
                newInfoTypeName.value = ''
                showAddInfoTypeDialog.value = false
                ElMessage.success('信息类型添加成功')
            } catch (error) {
                console.error('添加信息类型失败:', error)
                ElMessage.error('添加信息类型失败')
            }
        }

        // 检查人员电话是否重复
        const checkPeopleDuplicate = async (phone, newPeopleData) => {
            try {
                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.getPeople()
                if (response.status === 'ok') {
                    const existingPeople = response.people

                    // 检查电话是否已存在
                    const existingPerson = existingPeople.find(person => person.phone === phone)
                    if (existingPerson) {
                        // 电话已存在
                        duplicatePeople.phone = phone
                        duplicatePeople.existing = existingPerson
                        duplicatePeople.new = newPeopleData
                        showDuplicatePeopleDialog.value = true
                        return true
                    }
                } else {
                    throw new Error(response.message || '获取人员列表失败')
                }

                return false
            } catch (error) {
                console.error('检查人员重复失败:', error)
                return false
            }
        }

        // 处理重复信息取消
        const handleDuplicateCancel = () => {
            showDuplicateInfoDialog.value = false
        }

        // 处理重复信息确认
        const handleDuplicateConfirm = async () => {
            showDuplicateInfoDialog.value = false
            // 继续保存信息
            await saveInfoAfterDuplicateCheck()
        }

        // 处理人员重复取消
        const handlePeopleCancel = () => {
            showDuplicatePeopleDialog.value = false
        }

        // 处理人员修改
        const handlePeopleModify = () => {
            showDuplicatePeopleDialog.value = false
            // 打开编辑对话框
            if (duplicatePeople.existing) {
                editPeople(duplicatePeople.existing)
            }
        }

        // 处理人员覆盖
        const handlePeopleOverride = async () => {
            showDuplicatePeopleDialog.value = false
            // 覆盖现有人员信息
            try {
                if (duplicatePeople.existing) {
                    await axios.put(`/infodata/people/${duplicatePeople.existing.id}/`, duplicatePeople.new)
                    ElMessage.success('人员信息更新成功')
                    getPeopleList()
                }
            } catch (error) {
                console.error('更新人员信息失败:', error)
                ElMessage.error('更新人员信息失败')
            }
        }

        // 处理解析取消
        const handleParseCancel = () => {
            showParseConfirmDialog.value = false
        }

        // 处理解析确认
        const handleParseConfirm = () => {
            showParseConfirmDialog.value = false
            // 继续解析信息
            performParseInfo()
        }

        // 复制原始信息到剪贴板
        const copyRawInfo = (rawInfo) => {
            navigator.clipboard.writeText(rawInfo).then(() => {
                ElMessage.success('原始信息已复制到剪贴板')
            }).catch(err => {
                ElMessage.error('复制失败: ', err)
            })
        }

        // 更新信息状态
        const updateInfoStatus = async (info) => {
            try {
                // 将ID和状态一起放在请求体中
                const requestData = {
                    status: info.status
                };

                const response = await InfoService.updateInfo(info.id, requestData)
                if (response.status === 'ok') {
                    ElMessage.success('状态更新成功')
                    // 更新本地数据，避免重新加载整个列表
                    const index = infoList.value.findIndex(item => item.id === info.id)
                    if (index !== -1) {
                        infoList.value[index].status = info.status
                    }
                } else {
                    throw new Error(response.message || '状态更新失败')
                }
            } catch (error) {
                console.error('更新信息状态失败:', error)
                ElMessage.error('状态更新失败')
                // 恢复原来的状态
                getInfoList()
            }
        }

        // 保存信息前的重复检查
        const saveInfoAfterDuplicateCheck = async () => {
            if (!parsedInfo.value) {
                ElMessage.warning('请先解析信息')
                return
            }

            try {
                // 检查信息是否重复
                const isDuplicate = await checkInfoDuplicate({
                    raw_info: parsedInfo.value.raw_info
                })

                if (isDuplicate) {
                    // 如果发现重复，等待用户确认
                    return
                }

                // 准备保存的数据
                const saveData = {
                    info_type: parsedInfo.value.info_type,
                    info: {
                        phones: parsedInfo.value.phones,
                        province: parsedInfo.value.province,
                        city: parsedInfo.value.city,
                        district: parsedInfo.value.district,
                        address: parsedInfo.value.address,
                        name: parsedInfo.value.name,
                        raw_info: parsedInfo.value.raw_info,
                        status: '未发放'
                    },
                    people_list: []
                }

                // 检查人员电话是否重复
                for (const phone of parsedInfo.value.phones) {
                    if (newPeopleData[phone] && newPeopleData[phone].name) {
                        const isPeopleDuplicate = await checkPeopleDuplicate(phone, newPeopleData[phone])
                        if (isPeopleDuplicate) {
                            // 如果发现人员重复，等待用户处理
                            return
                        }
                    }
                }

                // 收集需要保存的人员数据
                for (const phone of parsedInfo.value.phones) {
                    if (phonePeopleMap.value[phone] && phonePeopleMap.value[phone].length > 0) {
                        // 如果已有匹配的人员，不需要额外添加
                    } else if (newPeopleData[phone] && newPeopleData[phone].name) {
                        // 如果有新输入的人员信息，需要添加
                        saveData.people_list.push(newPeopleData[phone])
                    }
                }

                // 使用新的 InfoService 替代旧的 axios 调用
                const response = await InfoService.saveParsedInfo(saveData)
                if (response.status === 'ok') {
                    ElMessage.success('信息保存成功')
                    console.log('保存结果:', response)
                    // 刷新数据列表
                    getInfoList()
                    getPeopleList()
                } else {
                    throw new Error(response.message || '保存信息失败')
                }
            } catch (error) {
                console.error('保存信息失败:', error)
                ElMessage.error('保存信息失败')
            }
        }

        // 保存解析后的信息
        const saveParsedInfo = async () => {
            await saveInfoAfterDuplicateCheck()
        }

        // Info分页相关方法
        const handleInfoSizeChange = (val) => {
            infoPageSize.value = val
            infoCurrentPage.value = 1
            getInfoList()
        }

        const handleInfoCurrentChange = (val) => {
            infoCurrentPage.value = val
            getInfoList()
        }

        // People分页相关方法
        const handlePeopleSizeChange = (val) => {
            peoplePageSize.value = val
            peopleCurrentPage.value = 1
            getPeopleList()
        }

        const handlePeopleCurrentChange = (val) => {
            peopleCurrentPage.value = val
            getPeopleList()
        }

        // 搜索Info
        const searchInfo = () => {
            infoCurrentPage.value = 1
            getInfoList()
        }

        // 搜索People
        const searchPeople = () => {
            peopleCurrentPage.value = 1
            getPeopleList()
        }

        // 排序Info
        const sortInfo = () => {
            getInfoList()
        }

        // 排序People
        const sortPeople = () => {
            getPeopleList()
        }

        // 加载用户信息
        const loadUserInfo = () => {
            const currentUser = AuthService.getCurrentUser();
            if (currentUser) {
                console.log('当前用户信息:', currentUser);
                user.value.name = currentUser.nickname || currentUser.username || '用户名';
                user.value.id = currentUser.userid || currentUser.id || 1;
                user.value.userType = currentUser.userType || 1;
                console.log("icon:", currentUser.icon);
                // 如果有头像信息，则更新头像路径
                if (currentUser.icon) {
                    // 规范化路径分隔符，将反斜杠转换为正斜杠
                    const normalizedIcon = currentUser.icon.replace(/\\/g, '/');
                    console.log('规范化后的icon路径:', normalizedIcon);

                    // 构建完整的后端服务器地址，确保头像从8000端口获取
                    if (normalizedIcon.startsWith('http')) {
                        console.log('完整URL:', normalizedIcon);
                        // 如果已经是完整URL，则直接使用
                        user.value.avatar = normalizedIcon;
                    } else if (normalizedIcon.startsWith('/extra-files/uploads/')) {
                        console.log('extra-files URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        user.value.avatar = `${config.API_BASE_URL}${normalizedIcon}`;
                    } else if (normalizedIcon.startsWith('uploads/')) {
                        console.log('uploads URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        //this.user.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;

                        user.value.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        //查看地址：`${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        console.log('user.value.avatar', user.value.avatar);
                    } else {
                        console.log('img URL:', normalizedIcon);
                        user.value.avatar = `${config.API_BASE_URL}/extra-files/uploads/${normalizedIcon}`;
                    }
                } else {
                    console.log('使用默认头像');
                    // 使用默认头像
                    user.value.avatar = require('@/assets/logo.png');
                }
            }
        }

        // 加载应用信息
        const loadAppInfo = async () => {
            try {
                const response = await UserMainService.getAllApps(user.value.userType);
                if (response.status === 200 && response.apps) {
                    apps.value = response.apps.map(app => ({
                        id: app.id,
                        name: app.name,
                        desc: app.desc,
                        link: app.name === '快速抢答' ? '/abhs' : app.link,
                        icon: app.icon || 'code',
                        used: app.used || false
                    }));
                }
            } catch (error) {
                console.error('获取应用数据失败:', error);
                apps.value = [
                    { id: 1, name: 'OJ练习', desc: '在线编程练习', link: '/CppOJ/', icon: 'code', used: true },
                    { id: 2, name: '任务清单', desc: '待办事项管理', link: '/todo', icon: 'list', used: true },
                    { id: 3, name: '时间线', desc: '时间记录管理', link: '/TimeLine/', icon: 'timeline', used: false },
                    { id: 4, name: '知识图谱', desc: '知识关系展示', link: '/Graph/', icon: 'share', used: false },
                    { id: 5, name: '快速抢答', desc: '抢答与记忆训练', link: '/abhs', icon: 'quiz', used: false },
                    { id: 6, name: '文件管理', desc: '文件上传下载', link: '/FileManage/', icon: 'folder', used: false },
                    { id: 7, name: '数据可视化', desc: '数据图表展示', link: '/DataVisual/', icon: 'bar_chart', used: false }
                ];
            }
        }

        // 组件挂载时获取数据
        onMounted(() => {
            // 加载用户信息和应用信息
            loadUserInfo()
            loadAppInfo()

            getInfoTypes()
            getInfoList()
            getPeopleList()
        })

        return {
            user,
            apps,
            infoList,
            peopleList,
            currentInfo,
            currentPeople,
            infoRelatedPeople,
            peopleRelatedInfos,
            showAddInfoDialog,
            showAddPeopleDialog,
            rawInfo,
            parsedInfo,
            infoTypes,
            provinces,
            districts,
            phonePeopleMap,
            newPeopleData,
            showAddInfoTypeDialog,
            newInfoTypeName,
            editInfo,
            deleteInfo,
            saveInfo,
            editPeople,
            deletePeople,
            savePeople,
            parseInfo,
            selectPeopleForPhone,
            addPeopleForPhone,
            addPhone,
            removePhone,
            removeRelatedPersonFromInfo,
            removeRelatedInfoFromPeople,
            onInfoTypeChange,
            onProvinceChange,
            onCityChange,
            onDistrictChange,
            addInfoType,
            saveParsedInfo,
            getStatusTagType,
            getPeopleStatusTagType,
            showDuplicateInfoDialog,
            duplicateInfo,
            showDuplicatePeopleDialog,
            duplicatePeople,
            handleDuplicateCancel,
            handleDuplicateConfirm,
            handlePeopleCancel,
            handlePeopleModify,
            handlePeopleOverride,
            showParseConfirmDialog,
            parseDuplicateInfo,
            handleParseCancel,
            handleParseConfirm,
            copyRawInfo,  // 新增的复制方法
            updateInfoStatus,  // 新增的状态更新方法
            updatePeopleStatus,  // 新增的人员状态更新方法
            // 分页相关
            infoCurrentPage,
            infoPageSize,
            infoTotalCount,
            infoSearchKeyword,
            infoSortField,
            infoSortOrder,
            peopleCurrentPage,
            peoplePageSize,
            peopleTotalCount,
            peopleSearchKeyword,
            peopleSortField,
            peopleSortOrder,
            handleInfoSizeChange,
            handleInfoCurrentChange,
            handlePeopleSizeChange,
            handlePeopleCurrentChange,
            searchInfo,
            searchPeople,
            sortInfo,
            sortPeople
        }
    }
}
</script>

<style scoped>
.data-view-container {
    padding: 20px;
    max-width: 100%;
    margin: 0 auto;
}

.panels-container {
    display: flex;
    gap: 20px;
    height: calc(100vh - 120px);
}

.panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #eee;
    border-radius: 8px;
    overflow: hidden;
}

.panel-header {
    padding: 15px 20px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.panel-header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.panel-content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
}

/* Info面板样式 */
.info-panel {
    flex: 1.2;
}

/* People面板样式 */
.people-panel {
    flex: 1.2;
}

/* 分析面板样式 */
.analysis-panel {
    flex: 1.6;
}

.analysis-section {
    margin-bottom: 20px;
}

.raw-info-input {
    margin-bottom: 15px;
}

.parse-button {
    display: block;
}

.form-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.form-item label {
    display: inline-block;
    width: 80px;
    font-weight: bold;
}

.phone-list-section {
    margin: 20px 0;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
}

.phone-list-section h4 {
    margin-top: 0;
}

.phone-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 4px;
}

.people-match {
    flex: 1;
}

.people-form {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
}

.save-section {
    margin-top: 30px;
    text-align: center;
}

/* 重复信息对比样式 */
.duplicate-comparison {
    text-align: center;
}

.comparison-container {
    display: flex;
    gap: 20px;
    margin: 20px 0;
}

.comparison-panel {
    flex: 1;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 15px;
    text-align: left;
}

.comparison-panel h4 {
    margin-top: 0;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
}

.info-content {
    min-height: 100px;
    background-color: #f9f9f9;
    padding: 10px;
    border-radius: 4px;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.similarity {
    margin-top: 10px;
    font-weight: bold;
    color: #e6a23c;
}

.people-info {
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 4px;
    margin: 15px 0;
}

.people-info p {
    margin: 5px 0;
}

/* 控制栏样式 */
.controls-bar {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: wrap;
    gap: 10px;
}

.total-count {
    margin-left: auto;
    font-weight: bold;
    color: #606266;
}

/* 分页控件样式 */
.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

/* 关联列表样式 */
.related-people-list,
.related-infos-list {
    max-height: 150px;
    overflow-y: auto;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: #f9f9f9;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .panels-container {
        flex-direction: column;
        height: auto;
    }

    .panel {
        min-height: 300px;
    }

    .comparison-container {
        flex-direction: column;
    }

    .controls-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .total-count {
        margin-left: 0;
        text-align: center;
        margin-top: 10px;
    }
}
</style>